import { useState } from 'react';

import { prepareChosenSlotsRows } from './prepareChosenSlotsRows';
import { BookingSlot } from '../../api/search';
import {
  getDayTimesToRemove,
  findDependencies,
} from '../../components/PickTimesPopup';
import { ChosenSlots, DateSlots, DayTime } from '../../contexts/checkout';

export default function useDailyChosenState(
  initialChosenSlots: ChosenSlots = {},
  dateSlots: DateSlots,
  slots: BookingSlot[]
) {
  const [chosenSlots, setChosenSlots] =
    useState<ChosenSlots>(initialChosenSlots);

  const chosenSlotsEntries = prepareChosenSlotsRows(
    chosenSlots,
    dateSlots,
    slots
  );

  const onDateSelect = (datestring: string, dayTimes: DayTime[]) => {
    setChosenSlots({
      ...chosenSlots,
      [datestring]: [...dayTimes],
    });
  };

  const removeSlot =
    (onEmptyList?: () => void) =>
    (dateString: string, dayTime: DayTime, compound = false) => {
      const itemsToRemove = getDayTimesToRemove(
        dayTime,
        chosenSlots[dateString] || [],
        findDependencies(dateSlots[dateString] || {})
      );
      const newDateSlots = (chosenSlots[dateString] || []).filter(
        (slot) => !itemsToRemove.includes(slot)
      );
      const newChosenSlots = {
        ...chosenSlots,
        [dateString]: newDateSlots,
      };
      if (!newDateSlots.length || compound) {
        delete newChosenSlots[dateString];
      }
      setChosenSlots(newChosenSlots);
      if (Object.keys(newChosenSlots).length === 0) {
        onEmptyList?.();
      }
    };

  return {
    chosenSlots,
    chosenSlotsEntries,
    onDateSelect,
    removeSlot,
    overwriteChosenSlots: setChosenSlots,
  };
}
